import { render, staticRenderFns } from "./OsAppSubMenu.vue?vue&type=template&id=153c7dd3&scoped=true"
import script from "./OsAppSubMenu.vue?vue&type=script&lang=ts"
export * from "./OsAppSubMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c7dd3",
  null
  
)

export default component.exports